import ApplicationController from './application_controller'
import Sortable from "sortablejs";

// Reorder a release's tracks by dragging, or with the Move up/down buttons:
// renumbers the hidden position inputs, then saves the order (Release#sort reflex)
export default class extends ApplicationController {
  connect () {
    super.connect()
    this.sortable = Sortable.create(this.element, {onUpdate: this.onUpdateTrack.bind(this)})
  }

  // Keyboard alternative to dragging (the "Move up/down" buttons)
  moveUp(event) {
    this.move(event.currentTarget, -1)
  }

  moveDown(event) {
    this.move(event.currentTarget, 1)
  }

  move(button, direction) {
    const item = button.closest('li')
    const sibling = direction < 0 ? item.previousElementSibling : item.nextElementSibling
    if (!sibling) return

    direction < 0 ? sibling.before(item) : sibling.after(item)
    button.focus()
    this.onUpdateTrack()
    const items = [...this.element.children]
    this.announce(`Moved to position ${items.indexOf(item) + 1} of ${items.length}`)
  }

  // The polite live region application.js uses for toasts
  announce(text) {
    let region = document.getElementById('sr-announcer-polite')
    if (!region) {
      region = document.createElement('div')
      region.id = 'sr-announcer-polite'
      region.className = 'clip'
      region.setAttribute('role', 'status')
      region.setAttribute('aria-live', 'polite')
      document.body.appendChild(region)
    }
    region.textContent = ''
    setTimeout(() => { region.textContent = text }, 100)
  }

  onUpdateTrack() {
    var index = 1;
    this.element.querySelectorAll("input").forEach((input) => {
      input.setAttribute("value", index++)
    })
    this.stimulate("release#sort")
  }
}
